/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_AnnualConfirmationResponse } from '../models/billing_AnnualConfirmationResponse';
import type { billing_ApproveBulkRequest } from '../models/billing_ApproveBulkRequest';
import type { billing_ApproveBulkResponse } from '../models/billing_ApproveBulkResponse';
import type { billing_ApproveEmailResponse } from '../models/billing_ApproveEmailResponse';
import type { billing_CockpitListResponse } from '../models/billing_CockpitListResponse';
import type { billing_EmailDraftResponse } from '../models/billing_EmailDraftResponse';
import type { billing_EmailLogResponse } from '../models/billing_EmailLogResponse';
import type { billing_EmailLogsListResponse } from '../models/billing_EmailLogsListResponse';
import type { billing_GenerateInvoicesRequest } from '../models/billing_GenerateInvoicesRequest';
import type { billing_GenerateInvoicesResponse } from '../models/billing_GenerateInvoicesResponse';
import type { billing_InvoiceDTO } from '../models/billing_InvoiceDTO';
import type { billing_InvoiceListResponse } from '../models/billing_InvoiceListResponse';
import type { billing_InvoiceOverrideDTO } from '../models/billing_InvoiceOverrideDTO';
import type { billing_InvoiceOverrideListResponse } from '../models/billing_InvoiceOverrideListResponse';
import type { billing_InvoiceResponse } from '../models/billing_InvoiceResponse';
import type { billing_InvoiceRevisionListResponse } from '../models/billing_InvoiceRevisionListResponse';
import type { billing_InvoiceSplitsResponse } from '../models/billing_InvoiceSplitsResponse';
import type { billing_PrepareInvoiceEmailRequest } from '../models/billing_PrepareInvoiceEmailRequest';
import type { billing_PrepareInvoiceEmailResponse } from '../models/billing_PrepareInvoiceEmailResponse';
import type { billing_PreviewInvoicesRequest } from '../models/billing_PreviewInvoicesRequest';
import type { billing_PreviewInvoicesResponse } from '../models/billing_PreviewInvoicesResponse';
import type { billing_RejectEmailRequest } from '../models/billing_RejectEmailRequest';
import type { billing_RejectEmailResponse } from '../models/billing_RejectEmailResponse';
import type { billing_ResendEmailRequest } from '../models/billing_ResendEmailRequest';
import type { billing_ResendEmailResponse } from '../models/billing_ResendEmailResponse';
import type { billing_SendInvoiceEmailRequest } from '../models/billing_SendInvoiceEmailRequest';
import type { billing_SendInvoiceEmailResponse } from '../models/billing_SendInvoiceEmailResponse';
import type { billing_SubsidyCorrectionRequest } from '../models/billing_SubsidyCorrectionRequest';
import type { billing_SubsidyCorrectionResponse } from '../models/billing_SubsidyCorrectionResponse';
import type { billing_ToggleManualHoldRequest } from '../models/billing_ToggleManualHoldRequest';
import type { billing_ToggleManualHoldResponse } from '../models/billing_ToggleManualHoldResponse';
import type { billing_UpdateEmailDraftRequest } from '../models/billing_UpdateEmailDraftRequest';
import type { billing_UpdateInvoiceRequest } from '../models/billing_UpdateInvoiceRequest';
import type { billing_UpdateInvoiceStatusRequest } from '../models/billing_UpdateInvoiceStatusRequest';
import type { billing_ValidateBillingRequest } from '../models/billing_ValidateBillingRequest';
import type { billing_ValidateBillingResponse } from '../models/billing_ValidateBillingResponse';
import type { models_CreateInvoiceOverrideRequest } from '../models/models_CreateInvoiceOverrideRequest';
import type { models_UpdateInvoiceOverrideRequest } from '../models/models_UpdateInvoiceOverrideRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvoicesService {
    /**
     * List invoices with filters
     * List invoices with optional filters for billing period (billing_year, billing_month), status, child (child_id, child_ids), childcare (childcare_ids), group (group_ids), contract (contract_id), contact (contact_id), contract_type, limit, and offset.
     * @param status Filter by status (DRAFT, ISSUED, PAID, CANCELLED)
     * @param billingYear Filter by billing year
     * @param billingMonth Filter by billing month (1-12)
     * @param childId Filter by child ID
     * @param contractId Filter by contract ID
     * @param contactId Filter by payer contact ID
     * @param childcareIds Childcare IDs to filter
     * @param groupIds Group IDs to filter
     * @param contractType Filter by contract type
     * @param childIds Child IDs to filter
     * @param limit Pagination limit (max 100)
     * @param offset Pagination offset
     * @param include Opt-in heavy fields (allowlist: line_items). Omitted by default for a slim payload.
     * @param view Set to 'parent' to filter subsidy and subsidy_supplement adjustments from each item (also auto-applied when the caller is authenticated as a parent)
     * @returns billing_InvoiceListResponse OK
     * @throws ApiError
     */
    public static getApiV1Invoices(
        status?: string,
        billingYear?: number,
        billingMonth?: number,
        childId?: string,
        contractId?: string,
        contactId?: string,
        childcareIds?: Array<string>,
        groupIds?: Array<string>,
        contractType?: 'regular' | 'subsidised' | 'all',
        childIds?: Array<string>,
        limit?: number,
        offset?: number,
        include?: Array<string>,
        view?: 'parent',
    ): CancelablePromise<billing_InvoiceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices',
            query: {
                'status': status,
                'billing_year': billingYear,
                'billing_month': billingMonth,
                'child_id': childId,
                'contract_id': contractId,
                'contact_id': contactId,
                'childcare_ids': childcareIds,
                'group_ids': groupIds,
                'contract_type': contractType,
                'child_ids': childIds,
                'limit': limit,
                'offset': offset,
                'include': include,
                'view': view,
            },
            errors: {
                400: `Invalid query parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to list invoices`,
            },
        });
    }
    /**
     * Get invoice by ID with line items
     * Get detailed invoice information including line items. Returns the
     * same InvoiceDTO shape as the list endpoint for consistency.
     * When view=parent is supplied OR the caller is authenticated as
     * a parent, subsidy and subsidy_supplement adjustments are
     * filtered out and SubtotalAmount is recomputed from the visible
     * adjustments so the parent-facing breakdown reconciles.
     * A resolved parent also gets caller_payer_id and caller_qr_reference (the QR
     * reference of their own payer copy); the parent view adds paid_at.
     * @param id Invoice ID (required)
     * @param view Set to 'parent' to filter subsidy and subsidy_supplement adjustments from the response
     * @returns billing_InvoiceDTO OK
     * @throws ApiError
     */
    public static getApiV1Invoices1(
        id: string,
        view?: 'parent',
    ): CancelablePromise<billing_InvoiceDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/{id}',
            path: {
                'id': id,
            },
            query: {
                'view': view,
            },
            errors: {
                400: `Missing or invalid invoice ID`,
                403: `Organization ID not found in token`,
                404: `Invoice not found`,
                500: `Failed to get invoice`,
            },
        });
    }
    /**
     * Update invoice with manual adjustments
     * Updates a DRAFT invoice with manual discounts and recalculates totals
     * @param id Invoice ID
     * @param invoice Invoice updates
     * @returns billing_InvoiceResponse OK
     * @throws ApiError
     */
    public static putApiV1Invoices(
        id: string,
        invoice: billing_UpdateInvoiceRequest,
    ): CancelablePromise<billing_InvoiceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/invoices/{id}',
            path: {
                'id': id,
            },
            body: invoice,
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Invoice not found`,
                409: `Cannot update non-draft invoice`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Correct (re-issue) a finalised invoice
     * Cancels a finalised+ invoice and re-issues a corrected DRAFT for the same contract and period. Works for departed children (terminated/cancelled contracts). Released payments become parked debtor credit that the corrected draft re-consumes on finalisation.
     * @param id Invoice ID
     * @returns billing_InvoiceResponse The newly created corrected DRAFT invoice
     * @throws ApiError
     */
    public static postApiV1InvoicesCorrect(
        id: string,
    ): CancelablePromise<billing_InvoiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{id}/correct',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid invoice ID`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Invoice not found`,
                409: `Invoice cannot be corrected (draft or already terminal)`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get email logs for invoice
     * Returns per-payer email delivery logs with status and timestamps
     * @param id Invoice ID
     * @returns billing_EmailLogsListResponse OK
     * @throws ApiError
     */
    public static getApiV1InvoicesEmailLogs(
        id: string,
    ): CancelablePromise<billing_EmailLogsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/{id}/email-logs',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Toggle manual hold on invoice
     * Sets or clears the manual hold flag that prevents automatic email sending
     * @param id Invoice ID
     * @param request Toggle request
     * @returns billing_ToggleManualHoldResponse OK
     * @throws ApiError
     */
    public static postApiV1InvoicesEmailManualHold(
        id: string,
        request: billing_ToggleManualHoldRequest,
    ): CancelablePromise<billing_ToggleManualHoldResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{id}/email-manual-hold',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Prepare invoice email draft
     * Creates email draft(s) with default body for an invoice's payer(s)
     * @param id Invoice ID
     * @param request Prepare request
     * @returns billing_PrepareInvoiceEmailResponse Created
     * @throws ApiError
     */
    public static postApiV1InvoicesEmailsPrepare(
        id: string,
        request: billing_PrepareInvoiceEmailRequest,
    ): CancelablePromise<billing_PrepareInvoiceEmailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{id}/emails/prepare',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * List invoice overrides
     * Lists all sticky override records for an invoice
     * @param id Invoice ID
     * @returns billing_InvoiceOverrideListResponse OK
     * @throws ApiError
     */
    public static getApiV1InvoicesOverrides(
        id: string,
    ): CancelablePromise<billing_InvoiceOverrideListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/{id}/overrides',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation failed`,
                401: `Authentication required`,
                403: `Forbidden`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create an invoice override
     * Creates a sticky override on an invoice. Phase 1 accepts only the subsidy_office scope.
     * @param id Invoice ID
     * @param request Override to create
     * @returns billing_InvoiceOverrideDTO Created
     * @throws ApiError
     */
    public static postApiV1InvoicesOverrides(
        id: string,
        request: models_CreateInvoiceOverrideRequest,
    ): CancelablePromise<billing_InvoiceOverrideDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{id}/overrides',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Parent scope not supported / invalid kind`,
                401: `Authentication required`,
                403: `Forbidden`,
                404: `Invoice not found`,
                409: `Invoice cancelled or credited, or a correction of this type already exists on the invoice`,
                422: `Validation failed`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete an invoice override
     * Soft-deletes an override (reverts the subsidy split to the engine-computed value)
     * @param id Invoice ID
     * @param overrideId Override ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1InvoicesOverrides(
        id: string,
        overrideId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/invoices/{id}/overrides/{overrideId}',
            path: {
                'id': id,
                'overrideId': overrideId,
            },
            errors: {
                400: `Validation failed`,
                401: `Authentication required`,
                403: `Forbidden`,
                404: `Override not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update an invoice override
     * Edits an override's value and/or reason
     * @param id Invoice ID
     * @param overrideId Override ID
     * @param request Fields to update
     * @returns billing_InvoiceOverrideDTO OK
     * @throws ApiError
     */
    public static patchApiV1InvoicesOverrides(
        id: string,
        overrideId: string,
        request: models_UpdateInvoiceOverrideRequest,
    ): CancelablePromise<billing_InvoiceOverrideDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/invoices/{id}/overrides/{overrideId}',
            path: {
                'id': id,
                'overrideId': overrideId,
            },
            body: request,
            errors: {
                400: `Validation failed`,
                401: `Authentication required`,
                403: `Forbidden`,
                404: `Override not found`,
                409: `Invoice cancelled/credited, or the override was modified by another user (stale)`,
                422: `Validation failed`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Download invoice PDF
     * Generate and download a PDF for a specific invoice and payer
     * @param id Invoice ID
     * @param payerId Payer contact ID
     * @param lang Language (de, en, fr, it, es, pt)
     * @returns binary PDF file
     * @throws ApiError
     */
    public static getApiV1InvoicesPdf(
        id: string,
        payerId: string,
        lang: string = 'de',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/{id}/pdf',
            path: {
                'id': id,
            },
            query: {
                'payer_id': payerId,
                'lang': lang,
            },
            errors: {
                400: `Missing or invalid parameters`,
                403: `Organization ID not found in token`,
                404: `Invoice or payer not found`,
                422: `Invoice not finalized or QR-IBAN not configured`,
                500: `Failed to generate PDF`,
            },
        });
    }
    /**
     * Regenerate invoice with current contract data
     * Recalculates a DRAFT invoice using the latest contract configuration
     * @param id Invoice ID
     * @returns billing_InvoiceResponse OK
     * @throws ApiError
     */
    public static postApiV1InvoicesRegenerate(
        id: string,
    ): CancelablePromise<billing_InvoiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{id}/regenerate',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Invoice not found`,
                409: `Cannot regenerate non-draft invoice`,
                422: `Settling-in not closed, its first invoice period not generated, or a BF / SBU confirmation expired under the hold setting (SUBSIDY_EXPIRED_HOLD): invoice held`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Resend the current invoice revision
     * Re-sends the current revision PDF to the payers and clears needs_resend (Phase 2)
     * @param id Invoice ID
     * @returns void
     * @throws ApiError
     */
    public static postApiV1InvoicesResend(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{id}/resend',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation failed`,
                401: `Authentication required`,
                403: `Forbidden`,
                404: `Invoice not found`,
                409: `Invoice not resendable`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List invoice revisions
     * Lists the immutable revision snapshots for an invoice (Phase 2)
     * @param id Invoice ID
     * @returns billing_InvoiceRevisionListResponse OK
     * @throws ApiError
     */
    public static getApiV1InvoicesRevisions(
        id: string,
    ): CancelablePromise<billing_InvoiceRevisionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/{id}/revisions',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation failed`,
                401: `Authentication required`,
                403: `Forbidden`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Send invoice email
     * Sends invoice email to one or all payers of a finalized invoice
     * @param id Invoice ID
     * @param request Send request
     * @returns billing_SendInvoiceEmailResponse Accepted
     * @throws ApiError
     */
    public static postApiV1InvoicesSend(
        id: string,
        request: billing_SendInvoiceEmailRequest,
    ): CancelablePromise<billing_SendInvoiceEmailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{id}/send',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                503: `Service Unavailable`,
            },
        });
    }
    /**
     * Get invoice splits (payer breakdown)
     * Get the breakdown of an invoice by payers
     * @param id Invoice ID
     * @returns billing_InvoiceSplitsResponse OK
     * @throws ApiError
     */
    public static getApiV1InvoicesSplits(
        id: string,
    ): CancelablePromise<billing_InvoiceSplitsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/{id}/splits',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing invoice ID`,
                403: `Organization ID not found in token`,
                404: `Invoice not found`,
                500: `Failed to get invoice splits`,
            },
        });
    }
    /**
     * Update invoice status
     * Update invoice status with comprehensive transition validation. Valid transitions: DRAFT→(FINALIZED,CANCELLED); FINALIZED→(SENT,CANCELLED); SENT→(PAID,PARTIAL,OVERDUE,CANCELLED); PARTIAL→(PAID,OVERDUE,CANCELLED); OVERDUE→(PAID,PARTIAL,CANCELLED); PAID→(CANCELLED) (releases applied payments to family credit). Final states (CANCELLED,CREDITED) allow no transitions.
     * @param id Invoice ID
     * @param request Status update
     * @returns billing_InvoiceDTO OK
     * @throws ApiError
     */
    public static putApiV1InvoicesStatus(
        id: string,
        request: billing_UpdateInvoiceStatusRequest,
    ): CancelablePromise<billing_InvoiceDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/invoices/{id}/status',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request, unknown status, or derived status target (paid/partial/overdue)`,
                403: `Organization ID not found in token`,
                404: `Invoice not found`,
                422: `Invalid status transition`,
                500: `Failed to update invoice status`,
            },
        });
    }
    /**
     * Correct the subvention amount on an invoice
     * Applies a manual +/- correction (in Rappen) to the computed subvention amount. Works on any invoice status except cancelled/credited; the correction is sticky (survives regenerate), routed to the subsidy split (not the parent total), and hidden from parents.
     * @param id Invoice ID
     * @param request Subvention correction
     * @returns billing_SubsidyCorrectionResponse Correction applied (clamped=true when the below-zero clamp reduced the applied delta)
     * @throws ApiError
     */
    public static postApiV1InvoicesSubsidyCorrection(
        id: string,
        request: billing_SubsidyCorrectionRequest,
    ): CancelablePromise<billing_SubsidyCorrectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{id}/subsidy-correction',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get the caller's annual confirmation numbers
     * Returns the calendar years in which the daycare has finalized at least one of the caller's children and, for the given year, one entry per finalized child with the caller's share per month, read from the finalization snapshot. Care amount = invoice total minus course line items and, unless the organisation includes them, the additional services; extra care days always count. A year without a finalized child answers 404 ANNUAL_CONFIRMATION_NOT_FINALIZED.
     * @param year Calendar year
     * @returns billing_AnnualConfirmationResponse OK
     * @throws ApiError
     */
    public static getApiV1InvoicesAnnualConfirmation(
        year?: number,
    ): CancelablePromise<billing_AnnualConfirmationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/annual-confirmation',
            query: {
                'year': year,
            },
            errors: {
                400: `Invalid year`,
                401: `Unauthorized`,
                403: `Not a resolved parent or organization missing`,
                404: `Year not finalized (ANNUAL_CONFIRMATION_NOT_FINALIZED)`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Download the caller's annual confirmation PDF
     * Renders the annual confirmation (Jahresbestaetigung) letters of the caller's finalized children for a calendar year, one page per child, from the finalization snapshot. child_id narrows to one letter. A year or child without a finalized letter answers 404 ANNUAL_CONFIRMATION_NOT_FINALIZED.
     * @param year Calendar year
     * @param childId One child's letter only
     * @param lang Language (de, en, fr, it, es, pt)
     * @returns binary PDF file
     * @throws ApiError
     */
    public static getApiV1InvoicesAnnualConfirmationPdf(
        year: number,
        childId?: string,
        lang?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/annual-confirmation/pdf',
            query: {
                'year': year,
                'child_id': childId,
                'lang': lang,
            },
            errors: {
                400: `Missing or invalid year, child_id or language`,
                401: `Unauthorized`,
                403: `Not a resolved parent or organization missing`,
                404: `Not finalized (ANNUAL_CONFIRMATION_NOT_FINALIZED)`,
                500: `Failed to generate annual confirmation`,
            },
        });
    }
    /**
     * Get invoices for a specific billing period
     * Get all invoices for the specified year and month
     * @param year Billing year
     * @param month Billing month (1-12)
     * @param status Filter by status
     * @param childIds Child IDs to filter (injected by middleware for parent users)
     * @returns billing_InvoiceListResponse OK
     * @throws ApiError
     */
    public static getApiV1InvoicesByPeriod(
        year: number,
        month: number,
        status?: string,
        childIds?: Array<string>,
    ): CancelablePromise<billing_InvoiceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/by-period',
            query: {
                'year': year,
                'month': month,
                'status': status,
                'child_ids': childIds,
            },
            errors: {
                400: `Invalid query parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to get invoices`,
            },
        });
    }
    /**
     * List email logs for cockpit
     * Returns paginated, filterable list of all invoice emails across the organization
     * @param status Comma-separated statuses
     * @param kind Comma-separated email kinds (invoice_send|dunning_reminder_1|dunning_reminder_2|dunning_reminder_3|dunning_final_notice|dunning_final_repeat)
     * @param periodYear Invoice billing period year
     * @param periodMonth Invoice billing period month (1-12)
     * @param search Search text (max 100 chars)
     * @param limit Items per page (default 25, max 100)
     * @param offset Offset (default 0)
     * @param sort Sort field: created_at|sent_at|status (default created_at)
     * @param order Sort order: asc|desc (default desc)
     * @returns billing_CockpitListResponse OK
     * @throws ApiError
     */
    public static getApiV1InvoicesEmails(
        status?: string,
        kind?: string,
        periodYear?: number,
        periodMonth?: number,
        search?: string,
        limit?: number,
        offset?: number,
        sort?: string,
        order?: string,
    ): CancelablePromise<billing_CockpitListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/emails',
            query: {
                'status': status,
                'kind': kind,
                'period_year': periodYear,
                'period_month': periodMonth,
                'search': search,
                'limit': limit,
                'offset': offset,
                'sort': sort,
                'order': order,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get a single email log
     * Returns one email log row (subject, body, status, dunning context) by id. Used by the Edit Email sheet — invoice emails reach this row via the per-invoice list too, but dunning emails have no invoice_id, so this id-keyed endpoint is the only way to load their rendered subject/body.
     * @param emailLogId Email Log ID
     * @returns billing_EmailLogResponse OK
     * @throws ApiError
     */
    public static getApiV1InvoicesEmails1(
        emailLogId: string,
    ): CancelablePromise<billing_EmailLogResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/emails/{email_log_id}',
            path: {
                'email_log_id': emailLogId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Update email draft body
     * Updates subject, body_html, body_text on an email log in draft/held status. The recipient of a dunning draft (kind dunning_*) is not editable: a changed recipient_email returns 422 DUNNING_RECIPIENT_FROM_CONTACT, because the letter goes to the billing contact of the account.
     * @param emailLogId Email Log ID
     * @param request Update request
     * @returns billing_EmailDraftResponse OK
     * @throws ApiError
     */
    public static putApiV1InvoicesEmails(
        emailLogId: string,
        request: billing_UpdateEmailDraftRequest,
    ): CancelablePromise<billing_EmailDraftResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/invoices/emails/{email_log_id}',
            path: {
                'email_log_id': emailLogId,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Approve email and trigger send
     * Approves an email draft, starts the send workflow
     * @param emailLogId Email Log ID
     * @returns billing_ApproveEmailResponse Accepted
     * @throws ApiError
     */
    public static postApiV1InvoicesEmailsApprove(
        emailLogId: string,
    ): CancelablePromise<billing_ApproveEmailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/emails/{email_log_id}/approve',
            path: {
                'email_log_id': emailLogId,
            },
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Reject email draft
     * Rejects an email draft with a reason
     * @param emailLogId Email Log ID
     * @param request Reject request
     * @returns billing_RejectEmailResponse OK
     * @throws ApiError
     */
    public static postApiV1InvoicesEmailsReject(
        emailLogId: string,
        request: billing_RejectEmailRequest,
    ): CancelablePromise<billing_RejectEmailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/emails/{email_log_id}/reject',
            path: {
                'email_log_id': emailLogId,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Resend a bounced or failed email
     * Re-queues a bounced/failed invoice email for another send attempt, optionally correcting the recipient address first
     * @param emailLogId Email Log ID
     * @param request Optional corrected recipient
     * @returns billing_ResendEmailResponse Accepted
     * @throws ApiError
     */
    public static postApiV1InvoicesEmailsResend(
        emailLogId: string,
        request?: billing_ResendEmailRequest,
    ): CancelablePromise<billing_ResendEmailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/emails/{email_log_id}/resend',
            path: {
                'email_log_id': emailLogId,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Approve multiple email drafts
     * Approves multiple email drafts and triggers send workflows
     * @param request Bulk approve request
     * @returns billing_ApproveBulkResponse Accepted
     * @throws ApiError
     */
    public static postApiV1InvoicesEmailsApproveBulk(
        request: billing_ApproveBulkRequest,
    ): CancelablePromise<billing_ApproveBulkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/emails/approve-bulk',
            body: request,
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Generate invoices for a billing period (SYNCHRONOUS)
     * Generate invoices for all active contracts in the specified period with idempotency protection
     * @param request Generation parameters
     * @returns billing_GenerateInvoicesResponse OK
     * @throws ApiError
     */
    public static postApiV1InvoicesGenerate(
        request: billing_GenerateInvoicesRequest,
    ): CancelablePromise<billing_GenerateInvoicesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/generate',
            body: request,
            errors: {
                400: `Invalid request parameters`,
                403: `Organization ID not found in token`,
                409: `Generation already in progress`,
                500: `Failed to generate invoices`,
            },
        });
    }
    /**
     * Stream invoice generation progress via Server-Sent Events (SSE)
     * Generates invoices for all active contracts in the specified period and streams real-time progress updates via SSE
     * @param year Year for invoice generation
     * @param month Month for invoice generation (1-12)
     * @param dryRun Dry run mode (preview only)
     * @param retryContractIds Contract IDs to retry
     * @param excludeContractIds Contract IDs to exclude
     * @param childcareIds Childcare IDs to filter
     * @param groupIds Group IDs to filter
     * @param contractType Contract type filter
     * @returns string SSE stream of progress events
     * @throws ApiError
     */
    public static getApiV1InvoicesGenerateStream(
        year: number,
        month: number,
        dryRun?: boolean,
        retryContractIds?: Array<string>,
        excludeContractIds?: Array<string>,
        childcareIds?: Array<string>,
        groupIds?: Array<string>,
        contractType?: 'regular' | 'subsidised' | 'all',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/generate/stream',
            query: {
                'year': year,
                'month': month,
                'dry_run': dryRun,
                'retry_contract_ids': retryContractIds,
                'exclude_contract_ids': excludeContractIds,
                'childcare_ids': childcareIds,
                'group_ids': groupIds,
                'contract_type': contractType,
            },
            errors: {
                400: `Invalid request parameters`,
                403: `Organization ID not found in token`,
                409: `Generation already in progress`,
                500: `Failed to generate invoices`,
            },
        });
    }
    /**
     * Preview invoices for a billing period
     * Preview invoices that would be generated without creating them
     * @param request Preview parameters
     * @returns billing_PreviewInvoicesResponse OK
     * @throws ApiError
     */
    public static postApiV1InvoicesPreview(
        request: billing_PreviewInvoicesRequest,
    ): CancelablePromise<billing_PreviewInvoicesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/preview',
            body: request,
            errors: {
                400: `Invalid request parameters`,
                403: `Organization ID not found in token`,
                429: `Rate limit exceeded`,
                500: `Failed to preview invoices`,
            },
        });
    }
    /**
     * Validate billing run before generation
     * Check for issues that would prevent successful invoice generation
     * @param request Validation parameters
     * @returns billing_ValidateBillingResponse OK
     * @throws ApiError
     */
    public static postApiV1InvoicesValidate(
        request: billing_ValidateBillingRequest,
    ): CancelablePromise<billing_ValidateBillingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/validate',
            body: request,
            errors: {
                400: `Invalid request parameters`,
                403: `Organization ID not found in token`,
                429: `Rate limit exceeded`,
                500: `Failed to validate billing run`,
            },
        });
    }
}
